/**
 * Раскрытие HTML-сущностей в чужих метаданных.
 *
 * Нужно обоим источникам: и Jamendo, и Internet Archive отдают названия с
 * сущностями как есть — в выдаче попалось «Rune X - Des K&ouml;nigs
 * Waldwanderung». Раскрываем до вставки в разметку, где строка всё равно
 * экранируется, так что в плеере стоит «Königs», а не мусор.
 *
 * Без DOM: числовые сущности плюс горстка именованных, которые реально
 * встречаются. Так функция работает и в тестах, где DOM нет.
 */
export function decodeEntities(s: string): string {
  if (!s.includes("&")) return s;

  const named: Record<string, string> = {
    amp: "&", lt: "<", gt: ">", quot: '"', apos: "'", nbsp: " ",
    auml: "ä", ouml: "ö", uuml: "ü", Auml: "Ä", Ouml: "Ö", Uuml: "Ü", szlig: "ß",
    eacute: "é", egrave: "è", ecirc: "ê", agrave: "à", acirc: "â", ccedil: "ç",
    iacute: "í", oacute: "ó", uacute: "ú", ntilde: "ñ", aacute: "á",
    aring: "å", oslash: "ø", aelig: "æ", mdash: "—", ndash: "–", hellip: "…",
  };

  const pass = (x: string) => x.replace(/&(#x?[0-9a-f]+|[a-z]+);/gi, (m, body: string) => {
    if (body[0] === "#") {
      const code = body[1]?.toLowerCase() === "x"
        ? parseInt(body.slice(2), 16)
        : parseInt(body.slice(1), 10);
      return Number.isFinite(code) && code > 0 && code <= 0x10ffff
        ? String.fromCodePoint(code) : m;
    }
    return named[body] ?? m;
  });

  /*
   * Разворачиваем до стабильности, а не за один проход: в метаданных архива
   * встречается многократное кодирование. «K&amp;amp;ouml;nigs» — это три
   * слоя, и двух проходов не хватало: в плеере оставалось «K&ouml;nigs».
   *
   * Потолок всё же есть — чужие данные не должны крутить цикл бесконечно.
   */
  let out = s;
  for (let i = 0; i < 4; i++) {
    const next = pass(out);
    if (next === out) break;
    out = next;
  }
  return out;
}

